(function() {
    angular
        .module('emarket.commons')
        .controller('EmMapController', ['$timeout', '$scope', '$q', '$log', '$element', function($timeout,
            $scope,
            $q,
            $log,
            $element) {
            var vm = this;
            var init = {
                latLng: {
                    lat: 19.780769,
                    lng: -70.687111
                },
                zoom: 6
            };

            //make eslint happy
            var scope = $scope;
            if (scope.searchable === undefined) {
                vm.searchable = true;
            } else {
                vm.searchable = scope.searchable;
            }

            var autocompleteService = new google.maps.places.AutocompleteService();
            var geocoder = new google.maps.Geocoder();

            var map = new google.maps.Map($element[0].querySelector('.map'), {
                zoom: init.zoom,
                center: init.latLng
            });
            var placeService = new google.maps.places.PlacesService(map);
            var marker;
            var listenerHandler;
            //convert autocomplete google maps to promise
            var getResults = function(address) {
                var promise = $q(function(resolve, reject) {
                    autocompleteService.getQueryPredictions({
                        input: address
                    },
                    function(data, error) {
                        if (error === 'OK') {
                            resolve(data);
                        } else {
                            reject(error);
                        }
                    });
                });
                return promise;
            };
            //handle errors returned by google maps
            var handleError = function(err) {
                $log.error(err);
                if (scope.onError) {
                    scope.onError(err);
                }
            };

            //get place detail based on a result from geocoder or getresults
            var getPlaceDetail = function(place) {
                var promise = $q(function(resolve, reject) {
                    placeService.getDetails({
                        placeId: place.place_id
                    },
                    function(details, error) {
                        if (error === 'OK') {
                            resolve(details);
                        } else {
                            reject(error);
                        }
                    });
                });
                return promise;
            };

            //notify position changes
            var updatePosition = function(details) {
                var address = details.address_components.filter(function(address) {
                    return address.types.indexOf('sublocality_level_1') !== -1;
                })[0];
                if (address) {
                    address = address.long_name;
                } else {
                    address = details.address_components.filter(function(address) {
                        return address.types.indexOf('locality') !== -1;
                    })[0];
                    address = 'Cerca de ' + address.long_name;
                }
                var latLng =
          details.geometry.location.lat() +
          ',' +
          details.geometry.location.lng() +
          ',' +
          address;
                scope.ngModel = latLng;
                $timeout(function() {
                    scope.onChange();
                });
            };

            //add a marker to the map and notify the position
            var addMarker = function(position) {
                if (marker) {
                    marker.setPosition(position);
                } else {
                    marker = new google.maps.Marker({
                        position: position,
                        map: map,
                        animation: google.maps.Animation.DROP,
                        draggable: true
                    });
                    listenerHandler = google.maps.event.addListener(marker,
                        'dragend',
                        function(event) {
                            geocoder.geocode({ latLng: event.latLng }, function(response,
                                status) {
                                if (status === 'OK') {
                                    var place = response[0];
                                    init.zoom = 14;
                                    init.latLng = place.geometry.location;
                                    getPlaceDetail(place).then(updatePosition);
                                } else {
                                    handleError(status);
                                }
                            });
                        });
                }
                init.zoom = 14;
                init.latLng = position;
                map.setZoom(init.zoom);
                map.setCenter(init.latLng);
            };

            //for the autocomplete use when select an item
            vm.getLatLng = function(place) {
                if (!place) {
                    return;
                }
                getPlaceDetail(place)
                    .then(function(details) {
                        updatePosition(details);
                        addMarker(details.geometry.location);
                    })
                    .catch(handleError);
            };

            //used for the autocomplete for search a list
            vm.search = function(input) {
                if (!input) {
                    return $q.when();
                }
                return getResults(input)
                    .then(function(p) {
                        return p;
                    })
                    .catch(handleError);
            };
            if (scope.ngModel) {
                var latLng;
                if (scope.ngModel.value) {
                    latLng = [ scope.ngModel.latLng.lat, scope.ngModel.latLng.lng ];
                } else {
                    latLng = scope.ngModel.split(',');
                }
                addMarker({ lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1]) });
            } else {
                if (marker) {
                    marker.setMap(null);
                }
            }

            var watchEvent = $scope.$watch(function() {
                return scope.resize;
            },
            function() {
                if (scope.resize === true) {
                    $timeout(function() {
                        google.maps.event.trigger(map, 'resize');
                        map.setCenter(init.latLng);
                        map.setZoom(init.zoom);
                    }, 200);
                }
            });
            $scope.$on('$destroy', function() {
                if (listenerHandler) {
                    listenerHandler.remove();
                }
                watchEvent();
            });
        }]);
}());
